import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const KEY = "footsie_cookie_ack";

export default function CookieBanner() {
    const [ack, setAck] = useState(() => {
        try { return localStorage.getItem(KEY) === "1"; } catch { return true; }
    });
    if (ack) return null;

    const accept = () => {
        try { localStorage.setItem(KEY, "1"); } catch (_) { /* ignore */ }
        setAck(true);
    };

    return (
        <div className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-6 z-40" data-testid="cookie-banner">
            <div className="max-w-3xl mx-auto brut-lg bg-white rounded-xl p-4 flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-[#FFE55C] border-2 border-[#0A0A0A] flex items-center justify-center shrink-0">
                    <Cookie className="w-5 h-5" />
                </div>
                <div className="flex-1 min-w-0 text-sm font-medium">
                    <div className="font-black mb-0.5">Just one crumb.</div>
                    We use a single essential auth cookie so you can stay logged in — no ads, no tracking, no third-party analytics. See our{" "}
                    <Link to="/privacy" className="underline">Privacy Policy</Link>.
                </div>
                <button
                    onClick={accept}
                    className="px-3 py-2 rounded-lg brut bg-[#0A0A0A] text-white font-bold text-sm shrink-0"
                    data-testid="cookie-accept"
                >
                    OK
                </button>
                <button
                    onClick={accept}
                    className="p-1 shrink-0 hover:bg-[#0A0A0A]/10 rounded"
                    aria-label="Dismiss"
                    data-testid="cookie-dismiss"
                >
                    <X className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
}
